export const environment = {
  NODE_ENV: null,
  GA_ID: null,
  FIREBASE_CONFIG: null,
  production: true,
  configFile: 'assets/config/config.qa.json'
};
